import script from "./report-pc.vue?vue&type=script&setup=true&lang=js"
export * from "./report-pc.vue?vue&type=script&setup=true&lang=js"

import "./report-pc.vue?vue&type=style&index=0&id=05b676bc&lang=less&scoped=true"
import "./report-pc.vue?vue&type=style&index=1&id=05b676bc&lang=less"

import exportComponent from "/Users/timetravel/code/energy-storage-intelligence/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05b676bc"]])

export default __exports__